import { useEffect, useState } from "react";
import styled from "styled-components";
import * as C from "@components/customizing/customizingProducts/Customizing.styles";

const Div = styled.div`
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 10px;
  grid-row-gap: 10px;
  align-items: flex-start;

  @media screen and (max-width: 991px) {
    grid-template-columns: ${(props) =>
      props.less ? "repeat(2, 1fr)" : "repeat(3, 1fr)"};
  }

  @media screen and (max-width: 767px) {
    grid-template-columns: ${(props) =>
      props.less ? "repeat(2, 1fr)" : "repeat(3, 1fr)"};
  }
  @media screen and (max-width: 460px) {
    grid-template-columns: ${(props) =>
      props.less ? "repeat(2, 1fr)" : "repeat(3, 1fr)"};
  }
`;

const Title = styled.h6`
  width: 20%;
  @media (max-width: 991px) {
    width: 30%;
  }
`;

const CheckBox = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  :last-of-type {
    margin-right: 0;
  }
  & input {
    display: none;
  }
`;

const CheckBoxLabel = styled.label`
  width: 100%;
  font-size: 1rem;
  padding: 10px 10px;
  overflow: hidden;
  border: 2px solid #ececec;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: ${(props) => (props.checked ? "#3bb77e" : "black")};
  border-color: ${(props) => (props.checked ? "#3bb77e" : "#ececec")};
  border-radius: 10px;
  cursor: pointer;
  color: #696969;
  & img {
    margin: 0 auto;
  }

  .label_title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: pre-wrap;
    max-height: 1rem;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    max-width: 100%;
  }

  @media screen and (max-width: 767px) {
    font-size: 14px;
  }
  @media (max-width: 575px) {
    font-size: 12px;
  }
`;

const DetailImageDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
  width: 100%;

  img {
    width: auto;
    max-width: 100%;
    height: auto;
    margin-bottom: 10px;
    border-radius: 5px;
    object-fit: contain;
  }
`;

const DetailMentDiv = styled.div`
  margin-top: 10px;
  padding: 8px;
  background-color: white;
  border-radius: 5px;
  width: 100%;

  p {
    margin-bottom: 5px;
    font-size: 12px;
    color: #555;
    text-align: left;
  }
`;

// InfoIconWrapper 수정 - 상대적 위치 지정
const InfoIconWrapper = styled.span`
  //position: relative;
  display: inline-block;
  margin-left: 5px;
  z-index: 100;
`;

// InfoIcon
const InfoIcon = styled.span`
  color: gray;
  padding: 0 5px;
  cursor: pointer;
  border: 1px solid gray;
  border-radius: 50%;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;

  &:hover {
    color: #3bb77e;
    border-color: #3bb77e;
  }
`;

const HoverCart = styled.div`
  width: auto;
  min-width: 200px;
  max-width: 250px;
  max-height: 80vh;
  position: absolute;
  top: 0%;
  left: -28%;
  transform: translateX(-50%);
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.95);
  z-index: 101;
  display: none;
  padding: 15px;
  box-shadow: 0px 0px 20px 5px rgba(0, 0, 0, 0.3);
  overflow-y: auto;
  text-align: center;

  @media screen and (min-width: 768px) {
    ${InfoIconWrapper}:hover & {
      display: block;
    }
  }

  @media screen and (max-width: 767px) {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 10001;
    width: 90%;
    max-width: 350px;
  }
`;

// 모달 배경
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  display: ${(props) => (props.show ? "block" : "none")};
`;

// 모달 닫기 버튼
const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  color: #555;

  &:hover {
    color: #3bb77e;
  }
`;

const CustomImgSelect = ({
  title,
  code,
  options,
  register,
  openModal,
  reset,
  getValues,
  formState,
  watch,
  detailData,
  category,
}) => {
  const [selectedOption, setSelectedOption] = useState({});
  const [detailOption, setDetailOption] = useState(JSON.parse(detailData.Opt));
  const [showModal, setShowModal] = useState(false);
  const [currentDetailContent, setCurrentDetailContent] = useState({
    title: "",
    detailMent: [],
    detailImage: [],
  });

  // 모달 열기 함수
  const handleOpenModal = (oname, detailMent, detailImage) => {
    setCurrentDetailContent({
      title: oname,
      detailMent,
      detailImage,
    });
    setShowModal(true);
  };

  // 모달 닫기 함수
  const handleCloseModal = () => {
    setShowModal(false);
  };

  const onChangeSelectOption = (el, i) => (e) => {
    setSelectedOption({ ...setSelectedOption, [code]: el.okey });
    reset({
      ...getValues(),
      [code]: el.okey,
    });
  };

  // 옵션의 okey에 해당하는 상세 데이터 찾기 함수
  const findDetailInfo = (okey) => {
    // detailOption 배열에서 해당 okey를 가진 객체 찾기
    const detailItem = detailOption?.find(
      (item) => Object.keys(item)[0] === okey
    );

    // 해당 항목이 있으면 상세 정보 반환
    if (detailItem && detailItem[okey]) {
      return {
        detailMent: detailItem[okey].detailMent || [],
        detailImage: detailItem[okey].detailImage || [],
      };
    }

    // 없으면 빈 배열 반환
    return { detailMent: [], detailImage: [] };
  };

  useEffect(() => {
    setSelectedOption({});

    // options 배열이 존재하고 첫 번째 요소가 있을 경우에만 실행
    if (options && options.length > 0) {
      const firstOption = options[0];

      // 폼 리셋 및 첫 번째 옵션 선택
      reset({
        ...getValues(),
        [code]: firstOption.okey,
      });

      // 상태 업데이트
      setSelectedOption({ ...selectedOption, [code]: firstOption.okey });
    }
  }, [category, options]);

  return (
    <div style={{ position: "relative" }}>
      <Div less={options.length < 3}>
        {options.map((el, i) => {
          // 각 옵션마다 상세 정보 가져오기
          const { detailMent, detailImage } = findDetailInfo(el.okey);
          const hasDetails = detailMent.length > 0 || detailImage.length > 0;

          return (
            <CheckBox className="custome-checkbox" key={i}>
              <input
                type="radio"
                id={`${code}${i}`}
                className="form-check-input"
                value={el.okey}
                {...register(code)}
              />
              <CheckBoxLabel
                htmlFor={`${code}${i}`}
                value={el.okey}
                checked={watch(code) === el.okey}
                style={{
                  textTransform: "capitalize",
                }}
              >
                <img
                  src={
                    el.image !== "" ? el.image : "/assets/imgs/shop/cat-1.png"
                  }
                  alt={el.oname}
                />
                <span className="label_title">
                  {el.oname}
                  {hasDetails && (
                    <InfoIconWrapper>
                      <InfoIcon
                        onClick={(e) => {
                          e.preventDefault();
                          if (window.innerWidth <= 767) {
                            handleOpenModal(el.oname, detailMent, detailImage);
                          }
                        }}
                      >
                        ?
                      </InfoIcon>
                      <HoverCart>
                        <div
                          className="cart-row"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <div
                            className="cart-tumbnail"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "100%",
                              borderBottom: "0.5px solid #dee2e6",
                            }}
                          >
                            <h6
                              style={{
                                textAlign: "start",
                                marginTop: "10px",
                                marginBottom: "10px",
                                fontWeight: "bold",
                                fontSize: "16px",
                                width: "100%",
                              }}
                            >
                              {el.oname} 안내
                            </h6>
                          </div>

                          {/* 상세 이미지 표시 */}
                          {detailImage && detailImage.length > 0 && (
                            <DetailImageDiv>
                              {detailImage.map((imgSrc, idx) => (
                                <img
                                  key={idx}
                                  src={imgSrc}
                                  alt={`상세 이미지 ${idx + 1}`}
                                />
                              ))}
                            </DetailImageDiv>
                          )}
                        </div>
                      </HoverCart>
                    </InfoIconWrapper>
                  )}
                </span>
              </CheckBoxLabel>
            </CheckBox>
          );
        })}
      </Div>

      {/* 모바일용 모달 */}
      <ModalOverlay show={showModal} onClick={handleCloseModal}>
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            maxWidth: "350px",
            maxHeight: "80vh",
            backgroundColor: "white",
            borderRadius: "10px",
            padding: "20px",
            overflowY: "auto",
            zIndex: 10002,
          }}
        >
          <CloseButton onClick={handleCloseModal}>&times;</CloseButton>
          <h6
            style={{
              textAlign: "start",
              marginTop: "10px",
              marginBottom: "10px",
              fontWeight: "bold",
              fontSize: "16px",
              width: "100%",
              paddingBottom: "10px",
              borderBottom: "0.5px solid #dee2e6",
            }}
          >
            {currentDetailContent.title} 안내
          </h6>

          {/* 상세 이미지 표시 */}
          {currentDetailContent.detailImage &&
            currentDetailContent.detailImage.length > 0 && (
              <DetailImageDiv>
                {currentDetailContent.detailImage.map((imgSrc, idx) => (
                  <img key={idx} src={imgSrc} alt={`상세 이미지 ${idx + 1}`} />
                ))}
              </DetailImageDiv>
            )}
        </div>
      </ModalOverlay>
    </div>
  );
};

export default CustomImgSelect;
